<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Case Notes</h5>
  <div class="d-flex gap-2 align-items-center ms-auto">
    <button type="button" 
            class="btn btn-outline-secondary btn-sm" 
            (click)="viewHistory()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">
  <div class="text-center py-3" *ngIf="!notesLoaded">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="notes && notesLoaded" style="max-height: 500px; overflow-y: auto;">
    <div *ngFor="let note of notes.caseNotes" class="mb-3 pb-3 border-bottom">
      <div *ngIf="note" class="d-flex align-items-start">
        <div class="d-flex gap-2 me-3">
          <button type="button" 
                  class="btn btn-link text-danger p-0" 
                  (click)="deleteNote(note.id)" 
                  title="Delete">
            <fa-icon [icon]="faTrashAlt"></fa-icon>
          </button>
          <button *ngIf="note.canEdit" 
                  type="button" 
                  class="btn btn-link text-success p-0" 
                  (click)="editNote(note.id)" 
                  title="Edit">
            <fa-icon [icon]="faEdit"></fa-icon>
          </button>
        </div>
        <div style="flex: 1;">
          <app-case-note [caseNote]="note"></app-case-note>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-start">
  <button type="button" 
          class="btn btn-success rounded-circle" 
          (click)="addCaseNotes()"
          style="width: 40px; height: 40px;">
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</div>